import React, { useEffect, useState } from "react";
import { statTypes, tableTypes } from "../components/Table/utils";
import { filterTypes } from "../utils";

export const actionTypes = {
  season: 'season',
  competitionSportecId: 'competitionSportecId',
  competitionSlug: 'competitionSlug',
  badgeCount: 'badgeCount',
  club: 'club',
  clubSportecId: 'clubSportecId',
  clubs: 'clubs',
  position: 'position',
  appearances: 'appearances',
  route: "route",
  dateRange: "dateRange",
  versus: "versus",
  weather: "weather",
  phase: "phase",
  reset: "reset",
  apply: "apply",
  statType: "statType",
  currentQueryType: "currentQueryType",
  page: "page",
  desc: "desc",
  round: "round",
  clubSlug: "clubSlug"
};

export function filterReducer(state, action) {
  switch (action.type) {
    case actionTypes.season: {
      if (state.season === action.payload) {
        return { ...state, season: action.payload };
      }
      return { ...state, page: 0, season: action.payload };
    }
    case actionTypes.desc: {
      const { desc, statType } = action.payload;
      if (state.desc !== desc || state.statType !== statType) {
        return { ...state, page: 0, statType, desc };
      }

      return { ...state, desc, statType };
    }
    case actionTypes.page: {
      return { ...state, page: action.payload };
    }
    case actionTypes.competitionSportecId: {
      if (state.competitionSportecId === action.payload) {
        return { ...state, competitionSportecId: action.payload };
      }
      return { ...state, page: 0, competitionSportecId: action.payload };
    }
    case actionTypes.competitionSlug: {
      if (state.competitionSlug === action.payload) {
        return { ...state, competitionSlug: action.payload };
      }

      const matchCompetition = state?.competitions.find(competition => competition.slug === action.payload);

      const { sportecId, mlsPhaseType } = matchCompetition || {};
      const competitionSportecId = sportecId + "";
      return { ...state, page: 0, competitionSlug: action.payload, competitionSportecId, mlsPhaseType };
    }
    case actionTypes.badgeCount: {
      return { ...state, badgeCount: action.payload };
    }
    case actionTypes.club: {
      if (state.club === action.payload) {
        return { ...state, club: action.payload };
      }
      return { ...state, page: 0, club: action.payload };
    }
    case actionTypes.clubSportecId: {
      const clubSportecId = action.payload + "";
      return { ...state, page: 0, clubSportecId };
    }
    case actionTypes.clubs: {
      return { ...state, clubs: action.payload };
    }
    case actionTypes.position: {
      if (state.position === action.payload) {
        return { ...state, position: action.payload };
      }
      return { ...state, page: 0, position: action.payload };
    }
    case actionTypes.appearances: {
      if (state.appearances === action.payload) {
        return { ...state, appearances: action.payload };
      }
      return { ...state, page: 0, appearances: action.appearances };
    }
    case actionTypes.route: {
      if (state.route === action.payload) {
        return { ...state, route: action.payload };
      }
      return { ...state, page: 0, route: action.payload };
    }
    case actionTypes.weather: {
      if (state.weather === action.payload) {
        return { ...state, weather: action.payload };
      }
      return { ...state, page: 0, weather: action.payload };
    }
    case actionTypes.dateRange: {
      if (state.dateRange === action.payload) {
        return { ...state, dateRange: action.payload };
      }
      return { ...state, page: 0, dateRange: action.payload };
    }
    case actionTypes.versus: {
      if (state.versus === action.payload) {
        return { ...state, versus: action.payload };
      }
      return { ...state, page: 0, versus: action.payload };
    }
    case actionTypes.apply: {
      return { ...state, ...action.payload };
    }
    case actionTypes.statType: {
      return { ...state, statType: action.payload };
    }
    case actionTypes.currentQueryType: {
      const currentQueryType = action.payload;
      if (state.currentQueryType !== currentQueryType) {
        if (currentQueryType === statTypes.statsDefending) {
          return { ...state, page: 0, statType: "goals_conceded", currentQueryType };
        }
        if (currentQueryType === statTypes.statsPassing) {
          return { ...state, page: 0, statType: "accurate_pass", currentQueryType };
        }
        if (currentQueryType === statTypes.clubStatsGoalKeeping || currentQueryType === statTypes.statsGoalKeeping) {
          return { ...state, page: 0, statType: "saves", currentQueryType };
        }
        return { ...state, page: 0, statType: "goals", currentQueryType };
      }
      else {
        return { ...state };
      }
    }
    case actionTypes.round: {
      return { ...state, round: action.payload };
    }
    case actionTypes.clubSlug: {
      return { ...state, clubSlug: action.payload };
    }
    case actionTypes.reset: {
      return { ...state, ...action.payload };
    }
    default: {
      throw new Error(`Unsupported type: ${action.type}`);
    }
  }
}

export function useFilters({ initialState, reducer = filterReducer } = {}) {
  const { current: initialStateRef } = React.useRef(initialState);
  const [state, dispatch] = React.useReducer(reducer, initialStateRef);
  const [badgeCount, setBadgeCount] = useState(state.badgeCount);

  const updateFilter = (type) => (payload) => dispatch({ type, payload });
  const reset = (payload) => dispatch({ type: 'reset', payload });

  useEffect(() => {
    let counter = 0;

    if (state.tableType === tableTypes.players) {
      if (state.weather !== filterTypes.all) {
        counter++;
      }

      if (state.dateRange !== filterTypes.all) {
        counter++;
      }

      if (state.versus !== filterTypes.all) {
        counter++;
      }

      if (state.appearances !== filterTypes.all) {
        counter++;
      }

      if (state.position !== filterTypes.all) {
        counter++;
      }

      if (!state.preSelectedClub && state.clubSportecId !== filterTypes.allClubs) {
        counter++;
      }
    }

    setBadgeCount(counter);
  }, [state]);

  return {
    state,
    reset,
    badgeCount,
    updateFilter,
    initialStateRef,
  };
}
